export default __webpack_public_path__ + "static/media/markUnreadIcon.912541db.svg";